// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc } from '../../components/ProductOfferingConfigUtils.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditProductOfferingConfigQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditProductOfferingConfigQuery = { __typename?: 'Query', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } };

export type AddProductOfferingConfigMetaQueryVariables = Types.Exact<{
  productOfferingId: Types.Scalars['ID']['input'];
}>;


export type AddProductOfferingConfigMetaQuery = { __typename?: 'Query', productOffering: { __typename?: 'ProductOffering', id: string, publishToUnderwriting: boolean, name: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', displayName: string, order: number, active: boolean, id: string, name: string, optionConflicts: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionConflictChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }>, optionPrerequisites: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string } }>, optionGroup: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, required: boolean, isSingleOptionGroup: boolean, active: boolean, order: number, step?: { __typename?: 'CheckoutConfigOptionGroupStepDetail', code: Types.CheckoutConfigOptionGroupStep, name: string } | null | undefined } }>, project?:
      | { __typename: 'StandaloneProject' }
      | { __typename: 'Region' }
      | { __typename: 'Market' }
      | { __typename: 'Community', id: string, children: Array<{ __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType } }> }
      | { __typename: 'Subdivision' }
      | { __typename: 'Lot' }
      | { __typename: 'Structure' }
      | { __typename: 'Unit' }
     | null | undefined } };

export type AddProductOfferingConfig_ComputeQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  readyPlanOptionIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  originalReadyPlanOptionIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type AddProductOfferingConfig_ComputeQuery = { __typename?: 'Query', computeReadyPlanCost: { __typename?: 'ComputeReadyPlanCostResult', configurationErrors: Array<string>, readyPlan: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, protoProjectItems: Array<{ __typename?: 'ProtoProjectItem', totalCostInCents: number, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
       | null | undefined, modifyingTemplateItems: Array<
        | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
        | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      > }> } };

export type AddProductOfferingConfig_ProgramDataQueryVariables = Types.Exact<{
  readyPlanId: Types.Scalars['ID']['input'];
  readyPlanOptionIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type AddProductOfferingConfig_ProgramDataQuery = { __typename?: 'Query', computeProgramData: { __typename?: 'NewProgramData', sellableSqft?: number | null | undefined } };

export type AddProductOfferingConfig_ComputeResultFragment = { __typename?: 'ComputeReadyPlanCostResult', configurationErrors: Array<string>, readyPlan: { __typename?: 'ReadyPlan', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, order: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }> }, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, protoProjectItems: Array<{ __typename?: 'ProtoProjectItem', totalCostInCents: number, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
     | null | undefined, modifyingTemplateItems: Array<
      | { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
      | { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> }
    > }> };

export type AddProductOfferingConfig_LineItem_ItemTemplateItemVersion_Fragment = { __typename?: 'ItemTemplateItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type AddProductOfferingConfig_LineItem_ItemTemplateItem_Fragment = { __typename?: 'ItemTemplateItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type AddProductOfferingConfig_LineItem_ProjectCustomItem_Fragment = { __typename?: 'ProjectCustomItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type AddProductOfferingConfig_LineItem_TakeoffLineItem_Fragment = { __typename?: 'TakeoffLineItem', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type AddProductOfferingConfig_LineItem_TakeoffLineItemVersion_Fragment = { __typename?: 'TakeoffLineItemVersion', id: string, totalCostInCents: number, options: Array<{ __typename?: 'ReadyPlanOption', id: string, displayName: string }> };

export type AddProductOfferingConfig_LineItemFragment =
  | AddProductOfferingConfig_LineItem_ItemTemplateItemVersion_Fragment
  | AddProductOfferingConfig_LineItem_ItemTemplateItem_Fragment
  | AddProductOfferingConfig_LineItem_ProjectCustomItem_Fragment
  | AddProductOfferingConfig_LineItem_TakeoffLineItem_Fragment
  | AddProductOfferingConfig_LineItem_TakeoffLineItemVersion_Fragment
;

export type CreateProjectFromConfigMetaQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  projectId: Types.Scalars['ID']['input'];
  productOfferingConfigId: Types.Scalars['ID']['input'];
  skipDevelopment: Types.Scalars['Boolean']['input'];
}>;


export type CreateProjectFromConfigMetaQuery = { __typename?: 'Query', cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string }>, project?:
    | { __typename?: 'StandaloneProject', id: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
    | { __typename?: 'Region', id: string, children: Array<{ __typename?: 'Market', id: string, name: string }> }
    | { __typename?: 'Market', id: string, children: Array<{ __typename?: 'Community', id: string, name: string }> }
    | { __typename?: 'Community', id: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string }> }
    | { __typename?: 'Subdivision', id: string, children: Array<{ __typename?: 'Lot', id: string, name: string }> }
    | { __typename?: 'Lot', id: string, children: Array<{ __typename?: 'Structure', id: string, name: string }> }
    | { __typename?: 'Structure', id: string, children: Array<{ __typename?: 'Unit', id: string, name: string }> }
    | { __typename?: 'Unit', id: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }
  , productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string }>, productOffering: { __typename?: 'ProductOffering', id: string } }, enumDetails: { __typename?: 'AllEnumDetails', lotType: Array<{ __typename?: 'LotTypeDetail', code: Types.LotType, name: string }> }, projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > } };

export type CreateProjectFromProductOfferingConfigMutationVariables = Types.Exact<{
  input: Types.CreateProjectFromReadyPlanInput;
}>;


export type CreateProjectFromProductOfferingConfigMutation = { __typename?: 'Mutation', createProjectFromReadyPlan: { __typename?: 'SaveProjectResult', project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     } };

export type SaveProductOfferingConfigMutationVariables = Types.Exact<{
  input: Types.SaveProductOfferingConfigInput;
}>;


export type SaveProductOfferingConfigMutation = { __typename?: 'Mutation', saveProductOfferingConfig: { __typename?: 'SaveProductOfferingConfigResult', productOfferingConfig: { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> } } };

export type EditProductOfferingConfig_ProductOfferingConfigFragment = { __typename?: 'ProductOfferingConfig', id: string, name: string, isBaseConfig: boolean, salesPriceInCents?: number | null | undefined, publishToUnderwriting: boolean, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, active: boolean }> };

export const AddProductOfferingConfig_LineItemFragmentDoc = gql`
    fragment AddProductOfferingConfig_LineItem on BaseItemLike {
  id
  totalCostInCents
  options {
    id
    displayName
  }
}
    `;
export const AddProductOfferingConfig_ComputeResultFragmentDoc = gql`
    fragment AddProductOfferingConfig_ComputeResult on ComputeReadyPlanCostResult {
  readyPlan {
    id
    optionGroups {
      id
      order
      options {
        id
        displayName
      }
    }
  }
  readyPlanOptions {
    id
  }
  protoProjectItems {
    totalCostInCents
    itemTemplateItem {
      ...AddProductOfferingConfig_LineItem
    }
    modifyingTemplateItems {
      ...AddProductOfferingConfig_LineItem
    }
  }
  configurationErrors
}
    ${AddProductOfferingConfig_LineItemFragmentDoc}`;
export const EditProductOfferingConfig_ProductOfferingConfigFragmentDoc = gql`
    fragment EditProductOfferingConfig_ProductOfferingConfig on ProductOfferingConfig {
  id
  name
  isBaseConfig
  salesPriceInCents
  readyPlanOptions {
    id
    active
  }
  publishToUnderwriting
}
    `;
export const EditProductOfferingConfigDocument = gql`
    query EditProductOfferingConfig($id: ID!) {
  productOfferingConfig(id: $id) {
    ...EditProductOfferingConfig_ProductOfferingConfig
  }
}
    ${EditProductOfferingConfig_ProductOfferingConfigFragmentDoc}`;

/**
 * __useEditProductOfferingConfigQuery__
 *
 * To run a query within a React component, call `useEditProductOfferingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProductOfferingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProductOfferingConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditProductOfferingConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables> & ({ variables: EditProductOfferingConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
      }
export function useEditProductOfferingConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
        }
// @ts-ignore
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>;
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<EditProductOfferingConfigQuery | undefined, EditProductOfferingConfigQueryVariables>;
export function useEditProductOfferingConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>(EditProductOfferingConfigDocument, options);
        }
export type EditProductOfferingConfigQueryHookResult = ReturnType<typeof useEditProductOfferingConfigQuery>;
export type EditProductOfferingConfigLazyQueryHookResult = ReturnType<typeof useEditProductOfferingConfigLazyQuery>;
export type EditProductOfferingConfigSuspenseQueryHookResult = ReturnType<typeof useEditProductOfferingConfigSuspenseQuery>;
export type EditProductOfferingConfigQueryResult = ApolloReactCommon.QueryResult<EditProductOfferingConfigQuery, EditProductOfferingConfigQueryVariables>;
export const AddProductOfferingConfigMetaDocument = gql`
    query AddProductOfferingConfigMeta($productOfferingId: ID!) {
  productOffering(id: $productOfferingId) {
    id
    publishToUnderwriting
    ...Named
    version {
      id
    }
    status {
      code
      name
    }
    options {
      ...ProductOfferingConfigUtils_ReadyPlanOption
    }
    project {
      __typename
      ... on Community {
        id
        children {
          id
          lotType {
            code
          }
        }
      }
    }
  }
}
    ${NamedFragmentDoc}
${ProductOfferingConfigUtils_ReadyPlanOptionFragmentDoc}`;

/**
 * __useAddProductOfferingConfigMetaQuery__
 *
 * To run a query within a React component, call `useAddProductOfferingConfigMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductOfferingConfigMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductOfferingConfigMetaQuery({
 *   variables: {
 *      productOfferingId: // value for 'productOfferingId'
 *   },
 * });
 */
export function useAddProductOfferingConfigMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables> & ({ variables: AddProductOfferingConfigMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
      }
export function useAddProductOfferingConfigMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
        }
// @ts-ignore
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>;
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfigMetaQuery | undefined, AddProductOfferingConfigMetaQueryVariables>;
export function useAddProductOfferingConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>(AddProductOfferingConfigMetaDocument, options);
        }
export type AddProductOfferingConfigMetaQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaQuery>;
export type AddProductOfferingConfigMetaLazyQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaLazyQuery>;
export type AddProductOfferingConfigMetaSuspenseQueryHookResult = ReturnType<typeof useAddProductOfferingConfigMetaSuspenseQuery>;
export type AddProductOfferingConfigMetaQueryResult = ApolloReactCommon.QueryResult<AddProductOfferingConfigMetaQuery, AddProductOfferingConfigMetaQueryVariables>;
export const AddProductOfferingConfig_ComputeDocument = gql`
    query AddProductOfferingConfig_Compute($readyPlanId: ID!, $readyPlanOptionIds: [ID!]!, $originalReadyPlanOptionIds: [ID!]) {
  computeReadyPlanCost(
    input: {readyPlanId: $readyPlanId, readyPlanOptionIds: $readyPlanOptionIds, versionMode: LATEST, originalReadyPlanOptionIds: $originalReadyPlanOptionIds}
  ) {
    ...AddProductOfferingConfig_ComputeResult
  }
}
    ${AddProductOfferingConfig_ComputeResultFragmentDoc}`;

/**
 * __useAddProductOfferingConfig_ComputeQuery__
 *
 * To run a query within a React component, call `useAddProductOfferingConfig_ComputeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductOfferingConfig_ComputeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductOfferingConfig_ComputeQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      readyPlanOptionIds: // value for 'readyPlanOptionIds'
 *      originalReadyPlanOptionIds: // value for 'originalReadyPlanOptionIds'
 *   },
 * });
 */
export function useAddProductOfferingConfig_ComputeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables> & ({ variables: AddProductOfferingConfig_ComputeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>(AddProductOfferingConfig_ComputeDocument, options);
      }
export function useAddProductOfferingConfig_ComputeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>(AddProductOfferingConfig_ComputeDocument, options);
        }
// @ts-ignore
export function useAddProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>;
export function useAddProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfig_ComputeQuery | undefined, AddProductOfferingConfig_ComputeQueryVariables>;
export function useAddProductOfferingConfig_ComputeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>(AddProductOfferingConfig_ComputeDocument, options);
        }
export type AddProductOfferingConfig_ComputeQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ComputeQuery>;
export type AddProductOfferingConfig_ComputeLazyQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ComputeLazyQuery>;
export type AddProductOfferingConfig_ComputeSuspenseQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ComputeSuspenseQuery>;
export type AddProductOfferingConfig_ComputeQueryResult = ApolloReactCommon.QueryResult<AddProductOfferingConfig_ComputeQuery, AddProductOfferingConfig_ComputeQueryVariables>;
export const AddProductOfferingConfig_ProgramDataDocument = gql`
    query AddProductOfferingConfig_ProgramData($readyPlanId: ID!, $readyPlanOptionIds: [ID!]!) {
  computeProgramData(
    input: {readyPlan: $readyPlanId, readyPlanOptions: $readyPlanOptionIds}
  ) {
    sellableSqft
  }
}
    `;

/**
 * __useAddProductOfferingConfig_ProgramDataQuery__
 *
 * To run a query within a React component, call `useAddProductOfferingConfig_ProgramDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddProductOfferingConfig_ProgramDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddProductOfferingConfig_ProgramDataQuery({
 *   variables: {
 *      readyPlanId: // value for 'readyPlanId'
 *      readyPlanOptionIds: // value for 'readyPlanOptionIds'
 *   },
 * });
 */
export function useAddProductOfferingConfig_ProgramDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables> & ({ variables: AddProductOfferingConfig_ProgramDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>(AddProductOfferingConfig_ProgramDataDocument, options);
      }
export function useAddProductOfferingConfig_ProgramDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>(AddProductOfferingConfig_ProgramDataDocument, options);
        }
// @ts-ignore
export function useAddProductOfferingConfig_ProgramDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>;
export function useAddProductOfferingConfig_ProgramDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddProductOfferingConfig_ProgramDataQuery | undefined, AddProductOfferingConfig_ProgramDataQueryVariables>;
export function useAddProductOfferingConfig_ProgramDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>(AddProductOfferingConfig_ProgramDataDocument, options);
        }
export type AddProductOfferingConfig_ProgramDataQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ProgramDataQuery>;
export type AddProductOfferingConfig_ProgramDataLazyQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ProgramDataLazyQuery>;
export type AddProductOfferingConfig_ProgramDataSuspenseQueryHookResult = ReturnType<typeof useAddProductOfferingConfig_ProgramDataSuspenseQuery>;
export type AddProductOfferingConfig_ProgramDataQueryResult = ApolloReactCommon.QueryResult<AddProductOfferingConfig_ProgramDataQuery, AddProductOfferingConfig_ProgramDataQueryVariables>;
export const CreateProjectFromConfigMetaDocument = gql`
    query CreateProjectFromConfigMeta($developmentId: ID!, $projectId: ID!, $productOfferingConfigId: ID!, $skipDevelopment: Boolean!) {
  cohorts(filter: {development: [$developmentId]}) @skip(if: $skipDevelopment) {
    id
    name
  }
  project(id: $projectId) @include(if: $skipDevelopment) {
    id
    children {
      id
      name
    }
  }
  productOfferingConfig(id: $productOfferingConfigId) {
    id
    readyPlanOptions {
      id
    }
    productOffering {
      id
    }
  }
  enumDetails {
    lotType {
      code
      name
    }
  }
  projectsPage(
    filter: {type: [StandaloneProject], isTest: false, status: [ACTIVE]}
  ) {
    entities {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateProjectFromConfigMetaQuery__
 *
 * To run a query within a React component, call `useCreateProjectFromConfigMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromConfigMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateProjectFromConfigMetaQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      projectId: // value for 'projectId'
 *      productOfferingConfigId: // value for 'productOfferingConfigId'
 *      skipDevelopment: // value for 'skipDevelopment'
 *   },
 * });
 */
export function useCreateProjectFromConfigMetaQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables> & ({ variables: CreateProjectFromConfigMetaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
      }
export function useCreateProjectFromConfigMetaLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
        }
// @ts-ignore
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>;
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateProjectFromConfigMetaQuery | undefined, CreateProjectFromConfigMetaQueryVariables>;
export function useCreateProjectFromConfigMetaSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>(CreateProjectFromConfigMetaDocument, options);
        }
export type CreateProjectFromConfigMetaQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaQuery>;
export type CreateProjectFromConfigMetaLazyQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaLazyQuery>;
export type CreateProjectFromConfigMetaSuspenseQueryHookResult = ReturnType<typeof useCreateProjectFromConfigMetaSuspenseQuery>;
export type CreateProjectFromConfigMetaQueryResult = ApolloReactCommon.QueryResult<CreateProjectFromConfigMetaQuery, CreateProjectFromConfigMetaQueryVariables>;
export const CreateProjectFromProductOfferingConfigDocument = gql`
    mutation CreateProjectFromProductOfferingConfig($input: CreateProjectFromReadyPlanInput!) {
  createProjectFromReadyPlan(input: $input) {
    project {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateProjectFromProductOfferingConfigMutation__
 *
 * To run a mutation, you first call `useCreateProjectFromProductOfferingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFromProductOfferingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFromProductOfferingConfigMutation, { data, loading, error }] = useCreateProjectFromProductOfferingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectFromProductOfferingConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProjectFromProductOfferingConfigMutation, CreateProjectFromProductOfferingConfigMutationVariables>(CreateProjectFromProductOfferingConfigDocument, options);
      }
export type CreateProjectFromProductOfferingConfigMutationHookResult = ReturnType<typeof useCreateProjectFromProductOfferingConfigMutation>;
export type CreateProjectFromProductOfferingConfigMutationResult = ApolloReactCommon.MutationResult<CreateProjectFromProductOfferingConfigMutation>;
export const SaveProductOfferingConfigDocument = gql`
    mutation SaveProductOfferingConfig($input: SaveProductOfferingConfigInput!) {
  saveProductOfferingConfig(input: $input) {
    productOfferingConfig {
      ...EditProductOfferingConfig_ProductOfferingConfig
    }
  }
}
    ${EditProductOfferingConfig_ProductOfferingConfigFragmentDoc}`;

/**
 * __useSaveProductOfferingConfigMutation__
 *
 * To run a mutation, you first call `useSaveProductOfferingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProductOfferingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProductOfferingConfigMutation, { data, loading, error }] = useSaveProductOfferingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProductOfferingConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProductOfferingConfigMutation, SaveProductOfferingConfigMutationVariables>(SaveProductOfferingConfigDocument, options);
      }
export type SaveProductOfferingConfigMutationHookResult = ReturnType<typeof useSaveProductOfferingConfigMutation>;
export type SaveProductOfferingConfigMutationResult = ApolloReactCommon.MutationResult<SaveProductOfferingConfigMutation>;